module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/tv/tv.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/tv/tv.obj
// module id = 646
// module chunks = 0